/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Next_Stop_ConfirmInputs */

const vi_dashboard_driver_next_stop_confirm = /** @type {(inputs: Dashboard_Driver_Next_Stop_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao`)
};

/**

* @param {Dashboard_Driver_Next_Stop_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_next_stop_confirm = /** @type {((inputs?: Dashboard_Driver_Next_Stop_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Next_Stop_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_next_stop_confirm(inputs)
});